/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Box, Button, Container, Grid, Modal, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import { useSignInContext } from '../../providers/use-signin';
// import styles
import useStyles from '../../assets/styles/components/header';

// import icon svg
import { ReactComponent as IconArrowLeft } from '../../assets/images/svg/header/icon_arrow_left.svg';
import { ReactComponent as IconUser } from '../../assets/images/svg/header/icon_user.svg';
import { ReactComponent as IconLocation } from '../../assets/images/svg/address_list/icon_local.svg';
import { ReactComponent as IconSearch } from '../../assets/images/svg/shops/icon_pesquisa.svg';
import { ReactComponent as IconClose } from '../../assets/images/svg/shops/icon_fechar.svg';
import { ReactComponent as IconShop } from '../../assets/images/svg/user/icon_sugestao_estabelecimento.svg';
import { ReactComponent as IconPhone } from '../../assets/images/svg/user/fone.svg';

// import img
import imgLogo from '../../assets/images/svg/header/logo.png';

import SelectStateAndCity from '../SelectStateAndCity';
import { useShopContext } from '../../providers/use-shop';
import { SearchProductAndSubCategory } from '../../helpers/utils/SearchProductAndSubCategory';
import { getStorege, removeStorege } from '../../helpers/db_storage';
import { useTracking } from '../../hook/useTracking';
import { api } from '../../services';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const styleModalBottom = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

type Props = {
  children: any;
  CtRight?: any;
  onClose?: () => void;
};

const Header: FC<Props> = ({ children, CtRight, onClose }) => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signIn = useSignInContext();
  const {
    data,
    listMenuItensShop,
    setProductsSearch,
    setSubCategoriesSearch,
  }: any = useShopContext();

  const [openModalSelectStateCity, setOpenModalSelectStateCity] =
    useState(false);

  const [openModalCallPhone, setOpenModalCallPhone] = useState(false);

  const [dataStateCity, setDataStateCity] = useState<any>();
  const [showSearchItem, setShowSearchItem] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');

  const handleToPage = (url: string, replace = false) => {
    return navigate(url, { replace });
  };

  const dataStorage = JSON.parse(
    localStorage.getItem('@mais/delivery/dataStateCity') as string,
  );

  const handleGetLocalStorageDataStateCity = () => {
    if (dataStorage) {
      setDataStateCity(dataStorage);
    }
  };

  function safeParse<T = any>(value: string | null): T | null {
    if (!value || value === 'null' || value === '[object Object]') {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      console.warn('Erro ao parsear JSON do localStorage:', value, e);
      return null;
    }
  }

  useEffect(() => {
    if (search) {
      const result: any = SearchProductAndSubCategory(data, search);
      setProductsSearch(result.dataProducts);
      setSubCategoriesSearch(result.dataSubCategories);
    } else {
      setProductsSearch('');
      setSubCategoriesSearch('');
    }
  }, [search]);

  useEffect(() => {
    handleGetLocalStorageDataStateCity();
  }, []);

  let dataIdsGoogleMeta: any = localStorage.getItem(
    '@mais/delivery/dataStateCity/GA/GMT/PXL',
  );

  if (dataIdsGoogleMeta === '[object Object]') {
    localStorage.removeItem('@mais/delivery/dataStateCity/GA/GMT/PXL');
  }

  dataIdsGoogleMeta = safeParse(dataIdsGoogleMeta);

  const dataIdsGoogleMetaShop = safeParse(
    localStorage.getItem('@mais/delivery/shop'),
  );

  if (
    window.location.pathname.split('/')[2] === 'shop' &&
    (dataIdsGoogleMetaShop?.idMetaPixel ||
      dataIdsGoogleMetaShop?.dsGoogleAnalytics ||
      dataIdsGoogleMetaShop?.dsGoogleTagManager)
  ) {
    dataIdsGoogleMeta = JSON.parse(
      localStorage.getItem('@mais/delivery/shop') as '',
    );
  }

  useTracking({
    idPixel: dataIdsGoogleMeta?.idMetaPixel ?? '',
    idGA: dataIdsGoogleMeta?.dsGoogleAnalytics ?? '',
    idGTM: dataIdsGoogleMeta?.dsGoogleTagManager ?? '',
    tipo: 'cidade',
  });

  // valida se usuario está tentando voltar de uma promoção
  useEffect(() => {
    const handlePopstate = () => {
      const result = getStorege(
        '@mais/delivery/shop/request/product/promotion',
      );
      if (result?.idPromocao) {
        handleToPage(
          `/shop/detail/list/product/subcategorie/${window.btoa(
            data.shop?.idRestaurante,
          )}`,
          true,
        );
        removeStorege('@mais/delivery/shop/request/product/promotion');
      }
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const ComponetLeft: FC = () => {
    if (
      children === 'address' ||
      children === 'updateUser' ||
      children === 'SignUp' ||
      children === 'User' ||
      children === 'Promotions' ||
      children === 'Shops' ||
      children === 'Abount' ||
      children === 'Request' ||
      children === 'DetailRequest' ||
      children === 'FlavorRequest' ||
      children === 'AdditionalRequest' ||
      children === 'ShopsDetail' ||
      children === 'PaymentCredit' ||
      children === 'Cashback' ||
      children?.type === 'RequestProgress'
    ) {
      return (
        <Grid
          item
          container
          xs
          justifyContent="flex-start"
          alignItems="center"
          marginLeft="10px"
          zIndex={15}
        >
          <IconArrowLeft
            style={{ cursor: 'pointer', marginLeft: '0', zIndex: 15 }}
            onClick={() => navigate(-1)}
            className={classeStyle.iconLeft}
          />
        </Grid>
      );
    }
    if (children === 'OrderDataRegister') {
      return (
        <Grid
          item
          container
          xs
          justifyContent="flex-start"
          alignItems="center"
          marginLeft="10px"
          zIndex={15}
        >
          <IconArrowLeft
            style={{ cursor: 'pointer', marginLeft: '0', zIndex: 15 }}
            onClick={onClose && onClose}
            className={classeStyle.iconLeft}
          />
        </Grid>
      );
    }
    if (
      children === 'UserDetailRequest' ||
      children === 'UserDetailRequestRate' ||
      children?.type === 'UserRequestProgress' ||
      children === 'UserDetailRequestUploadFilePix'
    ) {
      return (
        <Grid
          item
          container
          xs
          justifyContent="flex-start"
          alignItems="center"
          marginLeft="10px"
          zIndex={15}
        >
          <IconArrowLeft
            style={{ cursor: 'pointer', marginLeft: '0', zIndex: 15 }}
            onClick={() => navigate(-1)}
            className={classeStyle.iconLeft}
          />
        </Grid>
      );
    }
    if (children === 'Segments') {
      return (
        <Grid
          item
          xs
          container
          justifyContent="flex-start"
          alignItems="center"
          onClick={() => setOpenModalSelectStateCity(true)}
        >
          <p className={classeStyle.textComponentLeft}>
            <IconLocation className={classeStyle.iconLeft} />

            {dataStateCity?.dsCidade}
          </p>
        </Grid>
      );
    }
    return <Grid item xs justifyContent="flex-end" alignItems="center" />;
  };

  const ComponetRight: FC = () => {
    if (
      children === 'home' ||
      children === 'User' ||
      children === 'Promotions' ||
      children === 'Shops' ||
      children === 'Abount' ||
      children === 'Request' ||
      children === 'Segments'
    ) {
      return (
        <Grid item xs justifyContent="flex-end" container marginRight="10px">
          {signIn.signed ? (
            <Grid onClick={() => handleToPage('/dashboard/user')}>
              <p className={classeStyle.textComponentRight}>
                Olá {signIn.data.user?.dsNome?.split(' ')[0]}
                <IconUser
                  style={{ cursor: 'pointer' }}
                  className={classeStyle.iconUser}
                />
              </p>
            </Grid>
          ) : (
            <Grid onClick={() => handleToPage('/sign/in')}>
              <p className={classeStyle.textComponentRight}>
                Login
                <IconUser
                  style={{ cursor: 'pointer' }}
                  className={classeStyle.iconUser}
                />
              </p>
            </Grid>
          )}
        </Grid>
      );
    }
    if (children === 'ShopsDetail') {
      return (
        <Grid item xs justifyContent="flex-end" container marginRight="10px">
          <Grid onClick={() => setShowSearchItem(true)}>
            <p className={classeStyle.textComponentRight}>
              <IconSearch
                style={{ cursor: 'pointer' }}
                width="20"
                height="20"
                className={classeStyle.iconUser}
              />
            </p>
          </Grid>
        </Grid>
      );
    }

    if (children === 'DetailRequest') {
      return (
        <Grid item xs justifyContent="flex-end" container marginRight="10px">
          <Grid
            onClick={() =>
              handleToPage(
                `/shop/detail/list/product/subcategorie/${window.btoa(
                  data.shop?.idRestaurante,
                )}`,
              )
            }
          >
            <p className={classeStyle.textComponentRight}>
              <IconShop
                style={{ cursor: 'pointer' }}
                className={classeStyle.iconUser}
              />
            </p>
          </Grid>
        </Grid>
      );
    }

    if (children?.type === 'RequestProgress') {
      return (
        <Grid item xs justifyContent="flex-end" container marginRight="10px">
          <Grid onClick={() => setOpenModalCallPhone(true)}>
            <p className={classeStyle.textComponentRight}>
              <IconPhone style={{ cursor: 'pointer' }} width={25} height={25} />
            </p>
          </Grid>
        </Grid>
      );
    }

    if (children === 'updateUser' && CtRight) {
      return (
        CtRight && (
          <Grid item xs justifyContent="flex-end" container marginRight="10px">
            {' '}
            <CtRight />{' '}
          </Grid>
        )
      );
    }
    return <Grid item xs justifyContent="flex-end" alignItems="center" />;
  };

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid textAlign="center" alignItems="center" container spacing={4}>
          <ComponetLeft />
          <Grid item xs={4}>
            <img src={imgLogo} alt="logo" className={classeStyle.logo} />
          </Grid>
          {showSearchItem ? (
            <>
              <Grid item xs justifyContent="flex-end" alignItems="center" />
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
                className={classeStyle.gridInput}
              >
                <IconClose
                  className={classeStyle.icon}
                  onClick={() => setShowSearchItem(false)}
                />
                <input
                  className={classeStyle.inputText}
                  type="text"
                  placeholder="Buscar estabelecimento ou seu produto favorito"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Grid>
            </>
          ) : (
            <ComponetRight />
          )}
        </Grid>
      </Box>
      <Modal
        open={openModalSelectStateCity}
        onClose={() => setOpenModalSelectStateCity(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <SelectStateAndCity />
        </Box>
      </Modal>
      <Modal
        open={openModalCallPhone}
        onClose={() => setOpenModalCallPhone(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModalBottom, height: '650px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconPhone width={45} height={55} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{
                fontWeight: '550',
                width: '100%',
                textAlign: 'center',
                margin: 0,
              }}
            >
              Ligação
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
              style={{ marginTop: 0 }}
            >
              <p>Deseja ligar para o estabelecimento?</p>
            </Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button
              className={classeStyle.btnSubmit}
              style={{ width: '80%' }}
              variant="contained"
            >
              <a
                style={{ color: '#fff', textDecoration: 'none', width: '100%' }}
                href={`tel:+55${children?.phone}`}
              >
                Sim
              </a>
            </Button>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button variant="text" onClick={() => setOpenModalCallPhone(false)}>
              <p className={classeStyle.textBtnKeepShopping}>Não</p>
            </Button>
          </Grid>
        </Box>
      </Modal>
    </Container>
  );
};
export default Header;
